document.addEventListener('DOMContentLoaded', function() {
    var tocBlocks = document.querySelectorAll('.wp-block-celebrate-suite-celebrate-in-page-navigation');

    tocBlocks.forEach(function(block) {
        var headings = document.querySelectorAll('h1[id]:not(#link-modal-title), h2[id], h3[id], h4[id], h5[id], h6[id]');

        headings.forEach(function(heading) {
            var itemDiv = document.createElement('div');
            itemDiv.className = 'celebrate-in-page-nav-item';

            var link = document.createElement('a');
            link.href = '#' + heading.id;
            link.textContent = heading.textContent || heading.id;

            itemDiv.appendChild(link);
            block.appendChild(itemDiv);
        });

    });
});
